import { defineStore } from "pinia";
import { useLoginStore } from "./LoginStore";
import type {
  IPlanPriceChangeReservationRepository,
  IPlanPriceChangeReservationResponse,
} from "~/interfaces/IPlanPriceChangeReservationRepository";
import { PlanPriceChangeReservationRepository } from "~/repositories/PlanPriceChangeReservationRepository";

export const usePlanPriceChangeReservationStore = defineStore("PlanPriceChangeReservationStore", () => {
  const repository: IPlanPriceChangeReservationRepository = new PlanPriceChangeReservationRepository();
  const loginStore = useLoginStore();

  const item = ref<IPlanPriceChangeReservationResponse>();

  const fetch = async (planId: string): Promise<void> => {
    if (loginStore.isLogin()) {
      item.value = await repository.fetch(planId);
    }
  };

  const set = async (planPriceId: string, sbPaymentId: number | null): Promise<void> => {
    await repository.set(planPriceId, sbPaymentId);
  };

  const cancel = async (planPriceId: string): Promise<void> => {
    await repository.cancel(planPriceId);
  };

  return {
    item,
    fetch,
    set,
    cancel,
  };
});
